import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import ClassNames from "classnames";

var CalloutContainer = function CalloutContainer(_ref) {
  var _ClassNames;

  var type = _ref.type,
      color = _ref.color,
      children = _ref.children;
  var classNames = ClassNames("callout", (_ClassNames = {}, _defineProperty(_ClassNames, "callout--".concat(color), color), _defineProperty(_ClassNames, "callout--".concat(type), type), _ClassNames));
  return React.createElement("div", {
    className: classNames
  }, children);
};

var CalloutNumber = function CalloutNumber(_ref2) {
  var number = _ref2.number;
  return React.createElement("div", {
    className: "callout__number"
  }, React.createElement("strong", {
    className: "t-display-3"
  }, number));
};

var CalloutIcon = function CalloutIcon(_ref3) {
  var _ClassNames2;

  var icon = _ref3.icon,
      iconStyle = _ref3.iconStyle;
  icon = icon || "book";
  iconStyle = iconStyle || "fal";
  var iconClassNames = ClassNames("icon", "icon--static", "icon--halo", "icon--lg", (_ClassNames2 = {}, _defineProperty(_ClassNames2, "".concat(iconStyle), iconStyle), _defineProperty(_ClassNames2, "fa-".concat(icon), icon), _ClassNames2));
  return React.createElement("div", {
    className: "callout__icon"
  }, React.createElement("i", {
    className: iconClassNames
  }));
};

var CalloutText = function CalloutText(_ref4) {
  var children = _ref4.children;
  return React.createElement("div", {
    className: "callout__text"
  }, children);
};

var Callout = function Callout(_ref5) {
  var term = _ref5.term,
      lead = _ref5.lead,
      color = _ref5.color,
      children = _ref5.children,
      number = _ref5.number,
      icon = _ref5.icon,
      iconStyle = _ref5.iconStyle;
  var type = term && number ? "term" : lead ? "lead" : false;
  var content;

  switch (type) {
    case "term":
      content = React.createElement(React.Fragment, null, React.createElement(CalloutNumber, {
        number: number
      }), React.createElement(CalloutText, null, React.createElement("p", {
        className: "t-display-6"
      }, term), children));
      break;

    case "lead":
      content = React.createElement(React.Fragment, null, React.createElement(CalloutIcon, {
        icon: icon,
        iconStyle: iconStyle
      }), React.createElement(CalloutText, {
        lead: true
      }, children));
      break;

    default:
      content = React.createElement(React.Fragment, null, React.createElement(CalloutIcon, {
        icon: icon
      }), React.createElement(CalloutText, null, children));
      break;
  }

  return React.createElement(CalloutContainer, {
    type: type,
    color: color
  }, content);
};

export default Callout;